<template>
  <auth-page>
    <h2 class="brand-text">Forgot Your Password?</h2>
    <b-form v-if="!success" @submit="onSubmit">
      <p>Enter the email you use for IIP and we'll help you create a new password.</p>
      <b-form-group>
        <label class="sr-only" for="email-input">Email</label>
        <input
          v-validate="'required|email'"
          id="email-input"
          :disabled="saving"
          :class="{ 'is-invalid' : errors.has('email') || apiErrors.email.length }"
          :value="fields.email"
          class="form-control"
          type="text"
          name="email"
          placeholder="Email"
          @input="setEmail"/>
        <validation-errors :validation-errors="[errors.first('email')]"/>
        <span v-if="!errors.has('email')">
          <validation-errors :validation-errors="apiErrors.email"/>
        </span>
      </b-form-group>
      <b-form-group>
        <b-button :disabled="disabled" type="submit" block variant="light">
          Reset Your Password
          <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
        </b-button>
      </b-form-group>
      <form-fail :form-errors="apiErrors.other"/>
    </b-form>
    <form-success :success="success">
      We've sent you an email with instructions to reset your password.
      <br>
      <br>
      Feel free to close this window.
    </form-success>
    <router-link :to="{name: 'login'}" class="link-light">
      <i class="fas fa-hand-point-left"></i>
      &nbsp;back to login
    </router-link>
  </auth-page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import authPage from '../../templates/auth-page'
import formFail from '../../common/form/form-fail'
import dynamicInput from '../../common/form/input'
import validationErrors from '../../common/form/validation-errors'
import formSuccess from '../../common/form/form-success'

export default {
  components: {
    authPage,
    formFail,
    dynamicInput,
    validationErrors,
    formSuccess
  },
  computed: {
    ...mapState('register/forms/forgotPassword', [
      'apiErrors',
      'success',
      'fields',
      'saving'
    ]),
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  created () {
    if (this.$route.query.email) {
      this.$store.commit('register/forms/forgotPassword/setField', {
        field: 'email',
        value: this.$route.query.email
      })
    }
  },
  methods: {
    ...mapActions({
      forgotPassword: 'register/forgotPassword'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.forgotPassword()
        }
      })
    },
    setEmail (e) {
      this.$store.commit('register/forms/forgotPassword/setField', {
        field: 'email',
        value: e.target.value
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/auth/forgot-password.vue